import GxepStore from "data/GxepStore";
import Dispatcher from "Dispatcher";
import GxepActions from "data/GxepActions";
import React from "react";
import {
    GenericXmlExportPasswordAdmin as Body,
    title,
} from "lib/genericXmlExportPassword/GenericXmlExportPasswordAdmin";
import asModal from "lib/modal/asModal";
import useFluxStore from "@armus/use-flux-store";

export const BackboneGenericXmlExportPasswordAdmin = asModal(title)(props => {
    const { triggerClose } = props;
    const state = useFluxStore(() => ({
        passwordsLO: GxepStore.getState(),
        onCancel: () => {
            Dispatcher.dispatch({
                type: GxepActions.DIALOG_CLOSED,
            });
            triggerClose();
        },
        onChange: (key, password) => Dispatcher.dispatch({
            type: GxepActions.UPDATE_PASSWORD,
            key,
            password,
        }),
        onSave: () => {
            Dispatcher.dispatch({
                type: GxepActions.START_SAVE,
            });
            triggerClose();
        },
    }), [
        GxepStore,
    ], [triggerClose]);
    return <Body {...state} />;
});



// WEBPACK FOOTER //
// ./app/lib/genericXmlExportPassword/GXEPModule.js